<template>
  <engagement-layout>
    <template #heading>{{ headerInfo.heading }}</template>
    <!-- <template #info-tooltip>{{ headerInfo.headingIconText }} </template> -->
    <template #sub-heading>{{ headerInfo.subHeading }}</template>

    <template #left-side-bar>
      <mds-list-group with-icon size="medium">
        <mds-list-group-item
          v-for="option in loanCategories"
          :value="option.value"
          :text="option.text"
          :active="option.active"
          :key="option.value"
          @click.native="selectmenu(option)"
        >
        </mds-list-group-item>
      </mds-list-group>
    </template>

    <template #right-side-bar>
      <div class="right-body-white-container">
        <adl-data-table
          :buttonText="buttonText"
          :buttonId="buttonId"
          :headers="headers"
          :rows="rows"
          @clickloanDetails="clickloanDetails"
          @compare="compareData"
          @createNew="createNew"
          @duplicateRow="duplicateRow"
          @renameRow="renameRow"
          @deleteRow="deleteRow"
          :actionButtonText="actionButtonText"
          :imagepath="imagepath"
        >
        </adl-data-table>
      </div>
    </template>

    <template #footer>
      <page-footer>
        <template #action-button-left>
          <mds-button
            size="large"
            variation="flat"
            @click="onBack"
            icon="caret-left"
          >
            Back
          </mds-button>
        </template>
        <template #action-button-right>
          <!-- <mds-button-container right-aligned>
           <mds-button type="button" variation="secondary" @click="onNext">
              Next
            </mds-button> 
          </mds-button-container> -->
        </template>
      </page-footer>
    </template>
    <!-- end of footer-slot-->
  </engagement-layout>
</template>

<script>
import { EngagementLayout, PageFooter } from "../../component";

import { MdsListGroup, MdsListGroupItem } from "@mds/list-group";
import AdlDataTable from "../custom/data-table/DataTable.vue";
import { MdsButton } from "@mds/button";

export default {
  components: {
    EngagementLayout,
    MdsListGroup,
    MdsListGroupItem,
    AdlDataTable,
    PageFooter,
    MdsButton,
  },
  async created() {},
  props: {
    headerInfo: {
      type: Object,
    },
    buttonId: {
      type: String,
    },
    buttonText: {
      type: String,
    },
    headers: {
      type: Array,
    },
    rows: {
      type: Array,
    },
    loanCategories: {
      type: Array,
    },
    actionButtonText: {
      type: String,
    },
    imagepath: {
      type: String,
    },
  },

  data() {
    return {
      selecteditem: 1,
    };
  },
  mounted() {},

  methods: {
    compareData(data) {
      this.$emit("compare", data);
    },
    createNew() {
      this.$emit("createNew");
    },

    duplicateRow(data) {
      this.$emit("duplicateRow", data);
    },
    renameRow(data) {
      this.$emit("renameRow", data);
    },
    deleteRow(data) {
      this.$emit("deleteRow", data);
    },

    onSelectedTab(tabId) {
      if (tabId == "areaChart") {
        this.selectedComponent = "chart-area";
      } else {
        this.selectedComponent = "chart-bar";
      }
    },
    onBack() {
      this.$router.push({ name: "engagement-tool-selection" });
    },
    onNext() {
      this.$router.push({ name: "loan-engagement-tool" });
    },
    clickloanDetails(data) {
      this.$emit("rowSelected", data);
    },

    async getLiablity(id) {
      await this.setLiablityInformation(id);
    },
    selectmenu(data) {
      this.selecteditem = data.value;
      this.$emit("selectfilteredMenu", data);
    },
  },
};
</script>

<style lang="scss">
@import "@mds/constants";
</style>
